function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError('Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === 'undefined' || !(Symbol.iterator in Object(arr)))
        return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i)
                break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally {
        try {
            if (!_n && _i['return'] != null)
                _i['return']();
        } finally {
            if (_d)
                throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr))
        return arr;
}
function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === 'undefined' || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === 'number') {
            if (it)
                o = it;
            var i = 0;
            var F = function F() {
            };
            return {
                s: F,
                n: function n() {
                    if (i >= o.length)
                        return { done: true };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null)
                    it.return();
            } finally {
                if (didErr)
                    throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
    }
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== 'undefined' && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base)
                return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
        object = _getPrototypeOf(object);
        if (object === null)
            break;
    }
    return object;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/toolbar/toolbarview
 */
/* globals console */
import View from '../view';
import FocusTracker from '@ckeditor/ckeditor5-utils/src/focustracker';
import FocusCycler from '../focuscycler';
import KeystrokeHandler from '@ckeditor/ckeditor5-utils/src/keystrokehandler';
import ToolbarSeparatorView from './toolbarseparatorview';
import getResizeObserver from '@ckeditor/ckeditor5-utils/src/dom/getresizeobserver';
import preventDefault from '../bindings/preventdefault.js';
import Rect from '@ckeditor/ckeditor5-utils/src/dom/rect';
import global from '@ckeditor/ckeditor5-utils/src/dom/global';
import {
    createDropdown,
    addToolbarToDropdown
} from '../dropdown/utils';
import { attachLinkToDocumentation } from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import verticalDotsIcon from '@ckeditor/ckeditor5-core/theme/icons/three-vertical-dots.svg';
import '../../theme/components/toolbar/toolbar.css';
/**
 * The toolbar view class.
 *
 * @extends module:ui/view~View
 * @implements module:ui/dropdown/dropdownpanelfocusable~DropdownPanelFocusable
 */
var ToolbarView = /*#__PURE__*/
function (_View) {
    _inherits(ToolbarView, _View);
    var _super = _createSuper(ToolbarView);
    /**
   * Creates an instance of the {@link module:ui/toolbar/toolbarview~ToolbarView} class.
   *
   * Also see {@link #render}.
   *
   * @param {module:utils/locale~Locale} locale The localization services instance.
   * @param {module:ui/toolbar/toolbarview~ToolbarOptions} [options] Configuration options of the toolbar.
   */
    function ToolbarView(locale, options) {
        var _this;
        _classCallCheck(this, ToolbarView);
        _this = _super.call(this, locale);
        var bind = _this.bindTemplate;
        var t = _this.t;
        /**
     * A reference to the options object passed to the constructor.
     *
     * @readonly
     * @member {module:ui/toolbar/toolbarview~ToolbarOptions}
     */
        _this.options = options || {};
        /**
     * Label used by assistive technologies to describe this toolbar element.
     *
     * @default 'Editor toolbar'
     * @member {String} #ariaLabel
     */
        _this.set('ariaLabel', t('Editor toolbar'));
        /**
     * A collection of toolbar items (buttons, dropdowns, etc.).
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */
        _this.items = _this.createCollection();
        /**
     * Tracks information about the DOM focus in the toolbar.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker}
     */
        _this.focusTracker = new FocusTracker();
        /**
     * An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}
     * to handle keyboard navigation in the toolbar.
     *
     * @readonly
     * @member {module:utils/keystrokehandler~KeystrokeHandler}
     */
        _this.keystrokes = new KeystrokeHandler();
        /**
     * An additional CSS class added to the {@link #element}.
     *
     * @observable
     * @member {String} #class
     */
        _this.set('class');
        /**
     * A (child) view containing {@link #items toolbar items}.
     *
     * @readonly
     * @member {module:ui/toolbar/toolbarview~ItemsView}
     */
        _this.itemsView = new ItemsView(locale);
        /**
     * A top–level collection aggregating building blocks of the toolbar.
     *
     *	┌───────────────── ToolbarView ─────────────────┐
     *	| ┌──────────────── #children ────────────────┐ |
     *	| |   ┌──────────── #itemsView ───────────┐   | |
     *	| |   | [ item1 ] [ item2 ] ... [ itemN ] |   | |
     *	| |   └──────────────────────────────────-┘   | |
     *	| └───────────────────────────────────────────┘ |
     *	└───────────────────────────────────────────────┘
     *
     * By default, it contains the {@link #itemsView} but it can be extended with additional
     * UI elements when necessary.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */
        _this.children = _this.createCollection();
        _this.children.add(_this.itemsView);
        /**
     * A collection of {@link #items} that take part in the focus cycling
     * (i.e. navigation using the keyboard). Usually, it contains a subset of {@link #items} with
     * some optional UI elements that also belong to the toolbar and should be focusable
     * by the user.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */
        _this.focusables = _this.createCollection();
        /**
     * Controls the orientation of toolbar items. Only available when
     * {@link module:ui/toolbar/toolbarview~ToolbarOptions#shouldGroupWhenFull dynamic items grouping}
     * is **disabled**.
     *
     * @observable
     * @member {Boolean} #isVertical
     */
        /**
     * Helps cycling over {@link #focusables focusable items} in the toolbar.
     *
     * @readonly
     * @protected
     * @member {module:ui/focuscycler~FocusCycler}
     */
        _this._focusCycler = new FocusCycler({
            focusables: _this.focusables,
            focusTracker: _this.focusTracker,
            keystrokeHandler: _this.keystrokes,
            actions: {
                // Navigate toolbar items backwards using the arrow[left,up] keys.
                focusPrevious: [
                    'arrowleft',
                    'arrowup'
                ],
                // Navigate toolbar items forwards using the arrow[right,down] keys.
                focusNext: [
                    'arrowright',
                    'arrowdown'
                ]
            }
        });
        _this.setTemplate({
            tag: 'div',
            attributes: {
                class: [
                    'ck',
                    'ck-toolbar',
                    bind.to('class')
                ],
                role: 'toolbar',
                'aria-label': bind.to('ariaLabel')
            },
            children: _this.children,
            on: {
                // https://github.com/ckeditor/ckeditor5-ui/issues/206
                mousedown: preventDefault(_assertThisInitialized(_this))
            }
        });
        /**
     * An instance of the active toolbar behavior that shapes its look and functionality.
     *
     * See {@link module:ui/toolbar/toolbarview~ToolbarBehavior} to learn more.
     *
     * @protected
     * @readonly
     * @member {module:ui/toolbar/toolbarview~ToolbarBehavior}
     */
        _this._behavior = _this.options.shouldGroupWhenFull ? new DynamicGrouping(_assertThisInitialized(_this)) : new StaticLayout(_assertThisInitialized(_this));
        return _this;
    }
    /**
   * @inheritDoc
   */
    _createClass(ToolbarView, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                _get(_getPrototypeOf(ToolbarView.prototype), 'render', this).call(this);
                // Children added before rendering should be known to the #focusTracker.
                var _iterator = _createForOfIteratorHelper(this.items), _step;
                try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var item = _step.value;
                        this.focusTracker.add(item.element);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally {
                    _iterator.f();
                }
                this.items.on('add', function (evt, item) {
                    _this2.focusTracker.add(item.element);
                });
                this.items.on('remove', function (evt, item) {
                    _this2.focusTracker.remove(item.element);
                });
                // Start listening for the keystrokes coming from #element.
                this.keystrokes.listenTo(this.element);
                this._behavior.render(this);
            }    /**
     * @inheritDoc
     */
        },
        {
            key: 'destroy',
            value: function destroy() {
                this._behavior.destroy();
                return _get(_getPrototypeOf(ToolbarView.prototype), 'destroy', this).call(this);
            }    /**
     * Focuses the first focusable in {@link #focusables}.
     */
        },
        {
            key: 'focus',
            value: function focus() {
                this._focusCycler.focusFirst();
            }    /**
     * Focuses the last focusable in {@link #focusables}.
     */
        },
        {
            key: 'focusLast',
            value: function focusLast() {
                this._focusCycler.focusLast();
            }    /**
     * A utility that expands the plain toolbar configuration into
     * {@link module:ui/toolbar/toolbarview~ToolbarView#items} using a given component factory.
     *
     * @param {Array.<String>} config The toolbar items configuration.
     * @param {module:ui/componentfactory~ComponentFactory} factory A factory producing toolbar items.
     */
        },
        {
            key: 'fillFromConfig',
            value: function fillFromConfig(config, factory) {
                var _this3 = this;
                config.map(function (name) {
                    if (name == '|') {
                        _this3.items.add(new ToolbarSeparatorView());
                    } else if (factory.has(name)) {
                        _this3.items.add(factory.create(name));
                    } else {
                        /**
           * There was a problem processing the configuration of the toolbar. The item with the given
           * name does not exist so it was omitted when rendering the toolbar.
           *
           * This warning usually shows up when the {@link module:core/plugin~Plugin} which is supposed
           * to provide a toolbar item has not been loaded or there is a typo in the configuration.
           *
           * Make sure the plugin responsible for this toolbar item is loaded and the toolbar configuration
           * is correct, e.g. {@link module:basic-styles/bold~Bold} is loaded for the `'bold'` toolbar item.
           *
           * You can use the following snippet to retrieve all available toolbar items:
           *
           *		Array.from( editor.ui.componentFactory.names() );
           *
           * @error toolbarview-item-unavailable
           * @param {String} name The name of the component.
           */
                        console.warn(attachLinkToDocumentation('toolbarview-item-unavailable: The requested toolbar item is unavailable.'), { name: name });
                    }
                });
            }
        }
    ]);
    return ToolbarView;
}(View);
/**
 * An inner block of the {@link module:ui/toolbar/toolbarview~ToolbarView} hosting its
 * {@link module:ui/toolbar/toolbarview~ToolbarView#items}.
 *
 * @private
 * @extends module:ui/view~View
 */
export {
    ToolbarView as default
};
var ItemsView = /*#__PURE__*/
function (_View2) {
    _inherits(ItemsView, _View2);
    var _super2 = _createSuper(ItemsView);
    /**
   * @inheritDoc
   */
    function ItemsView(locale) {
        var _this4;
        _classCallCheck(this, ItemsView);
        _this4 = _super2.call(this, locale);
        /**
     * A collection of items (buttons, dropdowns, etc.).
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */
        _this4.children = _this4.createCollection();
        _this4.setTemplate({
            tag: 'div',
            attributes: {
                class: [
                    'ck',
                    'ck-toolbar__items'
                ]
            },
            children: _this4.children
        });
        return _this4;
    }
    return ItemsView;
}(View);
/**
 * A toolbar behavior that makes it static and unresponsive to the changes of the environment.
 * At the same time, it also makes it possible to display a toolbar with a vertical layout
 * using the {@link module:ui/toolbar/toolbarview~ToolbarView#isVertical} property.
 *
 * @private
 * @implements module:ui/toolbar/toolbarview~ToolbarBehavior
 */
var StaticLayout = /*#__PURE__*/
function () {
    /**
   * Creates an instance of the {@link module:ui/toolbar/toolbarview~StaticLayout} toolbar
   * behavior.
   *
   * @param {module:ui/toolbar/toolbarview~ToolbarView} view An instance of the toolbar that this behavior
   * is added to.
   */
    function StaticLayout(view) {
        _classCallCheck(this, StaticLayout);
        var bind = view.bindTemplate;
        // Static toolbar can be vertical when needed.
        view.set('isVertical', false);
        // 1:1 pass–through binding, all ToolbarView#items are visible.
        view.itemsView.children.bindTo(view.items).using(function (item) {
            return item;
        });
        // 1:1 pass–through binding, all ToolbarView#items are focusable.
        view.focusables.bindTo(view.items).using(function (item) {
            return item;
        });
        view.extendTemplate({
            attributes: {
                class: [// When vertical, the toolbar has an additional CSS class.
                    bind.if('isVertical', 'ck-toolbar_vertical')]
            }
        });
    }
    /**
   * @inheritDoc
   */
    _createClass(StaticLayout, [
        {
            key: 'render',
            value: function render() {
            }    /**
     * @inheritDoc
     */
        },
        {
            key: 'destroy',
            value: function destroy() {
            }
        }
    ]);
    return StaticLayout;
}();
/**
 * A toolbar behavior that makes the items respond to changes in the geometry.
 *
 * In a nutshell, it groups {@link module:ui/toolbar/toolbarview~ToolbarView#items}
 * that do not fit visually into a single row of the toolbar (due to limited space).
 * Items that do not fit are aggregated in a dropdown displayed at the end of the toolbar.
 *
 *	┌──────────────────────────────────────── ToolbarView ──────────────────────────────────────────┐
 *	| ┌─────────────────────────────────────── #children ─────────────────────────────────────────┐ |
 *	| |   ┌─────── #itemsView ────────┐ ┌──────────────────────┐ ┌── #groupedItemsDropdown ───┐   | |
 *	| |   |       #ungroupedItems     | | ToolbarSeparatorView | |        #groupedItems       |   | |
 *	| |   └──────────────────────────-┘ └──────────────────────┘ └────────────────────────────┘   | |
 *	| |                                  \---------- only when toolbar items overflow --------/    | |
 *	| └───────────────────────────────────────────────────────────────────────────────────────────┘ |
 *	└───────────────────────────────────────────────────────────────────────────────────────────────┘
 *
 * @private
 * @implements module:ui/toolbar/toolbarview~ToolbarBehavior
 */
var DynamicGrouping = /*#__PURE__*/
function () {
    /**
   * Creates an instance of the {@link module:ui/toolbar/toolbarview~DynamicGrouping} toolbar
   * behavior.
   *
   * @param {module:ui/toolbar/toolbarview~ToolbarView} view An instance of the toolbar that this behavior
   * is added to.
   */
    function DynamicGrouping(view) {
        var _this5 = this;
        _classCallCheck(this, DynamicGrouping);
        /**
     * A collection of toolbar children.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */
        this.viewChildren = view.children;
        /**
     * A collection of focusable toolbar elements.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */
        this.viewFocusables = view.focusables;
        /**
     * A view containing toolbar items.
     *
     * @readonly
     * @member {module:ui/toolbar/toolbarview~ItemsView}
     */
        this.viewItemsView = view.itemsView;
        /**
     * Toolbar focus tracker.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker}
     */
        this.viewFocusTracker = view.focusTracker;
        /**
     * Toolbar locale.
     *
     * @readonly
     * @member {module:utils/locale~Locale}
     */
        this.viewLocale = view.locale;
        /**
     * Toolbar element.
     *
     * @readonly
     * @member {HTMLElement} #viewElement
     */
        /**
     * A subset of toolbar {@link module:ui/toolbar/toolbarview~ToolbarView#items}.
     * Aggregates items that fit into a single row of the toolbar and were not {@link #groupedItems grouped}
     * into a {@link #groupedItemsDropdown dropdown}. Items of this collection are displayed in the
     * {@link module:ui/toolbar/toolbarview~ToolbarView#itemsView}.
     *
     * When none of the {@link module:ui/toolbar/toolbarview~ToolbarView#items} were grouped, it
     * matches the {@link module:ui/toolbar/toolbarview~ToolbarView#items} collection in size and order.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */
        this.ungroupedItems = view.createCollection();
        /**
     * A subset of toolbar {@link module:ui/toolbar/toolbarview~ToolbarView#items}.
     * A collection of the toolbar items that do not fit into a single row of the toolbar.
     * Grouped items are displayed in a dedicated {@link #groupedItemsDropdown dropdown}.
     *
     * When none of the {@link module:ui/toolbar/toolbarview~ToolbarView#items} were grouped,
     * this collection is empty.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */
        this.groupedItems = view.createCollection();
        /**
     * The dropdown that aggregates {@link #groupedItems grouped items} that do not fit into a single
     * row of the toolbar. It is displayed on demand as the last of
     * {@link module:ui/toolbar/toolbarview~ToolbarView#children toolbar children} and offers another
     * (nested) toolbar which displays items that would normally overflow.
     *
     * @readonly
     * @member {module:ui/dropdown/dropdownview~DropdownView}
     */
        this.groupedItemsDropdown = this._createGroupedItemsDropdown();
        /**
     * An instance of the resize observer that helps dynamically determine the geometry of the toolbar
     * and manage items that do not fit into a single row.
     *
     * **Note:** Created in {@link #_enableGroupingOnResize}.
     *
     * @readonly
     * @member {module:utils/dom/getresizeobserver~ResizeObserver}
     */
        this.resizeObserver = null;
        /**
     * A cached value of the horizontal padding style used by {@link #_updateGrouping}
     * to manage the {@link module:ui/toolbar/toolbarview~ToolbarView#items} that do not fit into
     * a single toolbar line. This value can be reused between updates because it is unlikely that
     * the padding will change and re–using `Window.getComputedStyle()` is expensive.
     *
     * @readonly
     * @member {Number}
     */
        this.cachedPadding = null;
        // Only those items that were not grouped are visible to the user.
        view.itemsView.children.bindTo(this.ungroupedItems).using(function (item) {
            return item;
        });
        // Make sure all #items visible in the main space of the toolbar are "focuscycleable".
        this.ungroupedItems.on('add', this._updateFocusCycleableItems.bind(this));
        this.ungroupedItems.on('remove', this._updateFocusCycleableItems.bind(this));
        // Make sure the #groupedItemsDropdown is also included in cycling when it appears.
        view.children.on('add', this._updateFocusCycleableItems.bind(this));
        view.children.on('remove', this._updateFocusCycleableItems.bind(this));
        // ToolbarView#items is dynamic. When an item is added, it should be automatically
        // represented in either grouped or ungrouped items at the right index.
        // In other words #items == concat( #ungroupedItems, #groupedItems )
        // (in length and order).
        view.items.on('add', function (evt, item, index) {
            if (index > _this5.ungroupedItems.length) {
                _this5.groupedItems.add(item, index - _this5.ungroupedItems.length);
            } else {
                _this5.ungroupedItems.add(item, index);
            }
            // When a new ungrouped item joins in and lands in #ungroupedItems, there's a chance it causes
            // the toolbar to overflow.
            _this5._updateGrouping();
        });
        // When an item is removed from ToolbarView#items, it should be automatically
        // removed from either grouped or ungrouped items.
        view.items.on('remove', function (evt, item, index) {
            if (index > _this5.ungroupedItems.length) {
                _this5.groupedItems.remove(item);
            } else {
                _this5.ungroupedItems.remove(item);
            }
            // Whether removed from grouped or ungrouped items, there is a chance
            // some new space is available and we could do some ungrouping.
            _this5._updateGrouping();
        });
        view.extendTemplate({
            attributes: {
                class: [// To group items dynamically, the toolbar needs a dedicated CSS class.
                    'ck-toolbar_grouping']
            }
        });
    }
    /**
   * Enables dynamic items grouping based on the dimensions of the toolbar.
   *
   * @param {module:ui/toolbar/toolbarview~ToolbarView} view An instance of the toolbar that this behavior
   * is added to.
   */
    _createClass(DynamicGrouping, [
        {
            key: 'render',
            value: function render(view) {
                this.viewElement = view.element;
                this._enableGroupingOnResize();
            }    /**
     * Cleans up the internals used by this behavior.
     */
        },
        {
            key: 'destroy',
            value: function destroy() {
                // The dropdown may not be in ToolbarView#children at the moment of toolbar destruction
                // so let's make sure it's actually destroyed along with the toolbar.
                this.groupedItemsDropdown.destroy();
                this.resizeObserver.disconnect();
            }    /**
     * When called, it will check if any of the {@link #ungroupedItems} do not fit into a single row of the toolbar,
     * and it will move them to the {@link #groupedItems} when it happens.
     *
     * At the same time, it will also check if there is enough space in the toolbar for the first of the
     * {@link #groupedItems} to be returned back to {@link #ungroupedItems} and still fit into a single row
     * without the toolbar wrapping.
     *
     * @protected
     */
        },
        {
            key: '_updateGrouping',
            value: function _updateGrouping() {
                // Do no grouping–related geometry analysis when the toolbar is detached from visible DOM,
                // for instance before #render(), or after render but without a parent or a parent detached
                // from DOM. DOMRects won't work anyway and there will be tons of warning in the console and
                // nothing else.
                if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) {
                    return;
                }
                var wereItemsGrouped;
                // Group #items as long as some wrap to the next row. This will happen, for instance,
                // when the toolbar is getting narrow and there is not enough space to display all items in
                // a single row.
                while (this._areItemsOverflowing) {
                    this._groupLastItem();
                    wereItemsGrouped = true;
                }
                // If none were grouped now but there were some items already grouped before,
                // then, what the hell, maybe let's see if some of them can be ungrouped. This happens when,
                // for instance, the toolbar is stretching and there's more space in it than before.
                if (!wereItemsGrouped && this.groupedItems.length) {
                    // Ungroup items as long as none are overflowing or there are none to ungroup left.
                    while (this.groupedItems.length && !this._areItemsOverflowing) {
                        this._ungroupFirstItem();
                    }
                    // If the ungrouping ended up with some item wrapping to the next row,
                    // put it back to the group toolbar ("undo the last ungroup"). We don't know whether
                    // an item will wrap or not until we ungroup it (that's a DOM/CSS thing) so this
                    // clean–up is vital for the algorithm.
                    if (this._areItemsOverflowing) {
                        this._groupLastItem();
                    }
                }
            }    /**
     * Returns `true` when {@link module:ui/toolbar/toolbarview~ToolbarView#element} children visually overflow,
     * for instance if the toolbar is narrower than its members. Returns `false` otherwise.
     *
     * @private
     * @type {Boolean}
     */
        },
        {
            key: '_enableGroupingOnResize',
            /**
     * Enables the functionality that prevents {@link #ungroupedItems} from overflowing (wrapping to the next row)
     * upon resize when there is little space available. Instead, the toolbar items are moved to the
     * {@link #groupedItems} collection and displayed in a dropdown at the end of the row (which has its own nested toolbar).
     *
     * When called, the toolbar will automatically analyze the location of its {@link #ungroupedItems} and "group"
     * them in the dropdown if necessary. It will also observe the browser window for size changes in
     * the future and respond to them by grouping more items or reverting already grouped back, depending
     * on the visual space available.
     *
     * @private
     */
            value: function _enableGroupingOnResize() {
                var _this6 = this;
                var previousWidth;
                // TODO: Consider debounce.
                this.resizeObserver = getResizeObserver(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 1), entry = _ref2[0];
                    if (!previousWidth || previousWidth !== entry.contentRect.width) {
                        _this6._updateGrouping();
                        previousWidth = entry.contentRect.width;
                    }
                });
                this.resizeObserver.observe(this.viewElement);
                this._updateGrouping();
            }    /**
     * When called, it will remove the last item from {@link #ungroupedItems} and move it back
     * to the {@link #groupedItems} collection.
     *
     * The opposite of {@link #_ungroupFirstItem}.
     *
     * @private
     */
        },
        {
            key: '_groupLastItem',
            value: function _groupLastItem() {
                if (!this.groupedItems.length) {
                    this.viewChildren.add(new ToolbarSeparatorView());
                    this.viewChildren.add(this.groupedItemsDropdown);
                    this.viewFocusTracker.add(this.groupedItemsDropdown.element);
                }
                this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
            }    /**
     * Moves the very first item belonging to {@link #groupedItems} back
     * to the {@link #ungroupedItems} collection.
     *
     * The opposite of {@link #_groupLastItem}.
     *
     * @private
     */
        },
        {
            key: '_ungroupFirstItem',
            value: function _ungroupFirstItem() {
                this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first));
                if (!this.groupedItems.length) {
                    this.viewChildren.remove(this.groupedItemsDropdown);
                    this.viewChildren.remove(this.viewChildren.last);
                    this.viewFocusTracker.remove(this.groupedItemsDropdown.element);
                }
            }    /**
     * Creates the {@link #groupedItemsDropdown} that hosts the members of the {@link #groupedItems}
     * collection when there is not enough space in the toolbar to display all items in a single row.
     *
     * @private
     * @returns {module:ui/dropdown/dropdownview~DropdownView}
     */
        },
        {
            key: '_createGroupedItemsDropdown',
            value: function _createGroupedItemsDropdown() {
                var locale = this.viewLocale;
                var t = locale.t;
                var dropdown = createDropdown(locale);
                dropdown.class = 'ck-toolbar__grouped-dropdown';
                // Make sure the dropdown never sticks out to the left/right. It should be under the main toolbar.
                // (https://github.com/ckeditor/ckeditor5/issues/5608)
                dropdown.panelPosition = locale.uiLanguageDirection === 'ltr' ? 'sw' : 'se';
                addToolbarToDropdown(dropdown, []);
                dropdown.buttonView.set({
                    label: t('Show more items'),
                    tooltip: true,
                    icon: verticalDotsIcon
                });
                // 1:1 pass–through binding.
                dropdown.toolbarView.items.bindTo(this.groupedItems).using(function (item) {
                    return item;
                });
                return dropdown;
            }    /**
     * Updates the {@link module:ui/toolbar/toolbarview~ToolbarView#focusables focus–cycleable items}
     * collection so it represents the up–to–date state of the UI from the perspective of the user.
     *
     * For instance, the {@link #groupedItemsDropdown} can show up and hide but when it is visible,
     * it must be subject to focus cycling in the toolbar.
     *
     * See the {@link module:ui/toolbar/toolbarview~ToolbarView#focusables collection} documentation
     * to learn more about the purpose of this method.
     *
     * @private
     */
        },
        {
            key: '_updateFocusCycleableItems',
            value: function _updateFocusCycleableItems() {
                var _this7 = this;
                this.viewFocusables.clear();
                this.ungroupedItems.map(function (item) {
                    _this7.viewFocusables.add(item);
                });
                if (this.groupedItems.length) {
                    this.viewFocusables.add(this.groupedItemsDropdown);
                }
            }
        },
        {
            key: '_areItemsOverflowing',
            get: function get() {
                // An empty toolbar cannot overflow.
                if (!this.ungroupedItems.length) {
                    return false;
                }
                var element = this.viewElement;
                var uiLanguageDirection = this.viewLocale.uiLanguageDirection;
                var lastChildRect = new Rect(element.lastChild);
                var toolbarRect = new Rect(element);
                if (!this.cachedPadding) {
                    var computedStyle = global.window.getComputedStyle(element);
                    var paddingProperty = uiLanguageDirection === 'ltr' ? 'paddingRight' : 'paddingLeft';
                    // parseInt() is essential because of quirky floating point numbers logic and DOM.
                    // If the padding turned out too big because of that, the grouped items dropdown would
                    // always look (from the Rect perspective) like it overflows (while it's not).
                    this.cachedPadding = Number.parseInt(computedStyle[paddingProperty]);
                }
                if (uiLanguageDirection === 'ltr') {
                    return lastChildRect.right > toolbarRect.right - this.cachedPadding;
                } else {
                    return lastChildRect.left < toolbarRect.left + this.cachedPadding;
                }
            }
        }
    ]);
    return DynamicGrouping;
}();    /**
 * Options passed to the {@link module:ui/toolbar/toolbarview~ToolbarView#constructor} of the toolbar.
 *
 * @interface module:ui/toolbar/toolbarview~ToolbarOptions
 */
        /**
 * When set to `true`, the toolbar will automatically group {@link module:ui/toolbar/toolbarview~ToolbarView#items} that
 * would normally wrap to the next line when there is not enough space to display them in a single row, for
 * instance, if the parent container of the toolbar is narrow.
 *
 * @member {Boolean} module:ui/toolbar/toolbarview~ToolbarOptions#shouldGroupWhenFull
 */
        /**
 * A class interface defining the behavior of the {@link module:ui/toolbar/toolbarview~ToolbarView}.
 *
 * Toolbar behaviors extend its look and functionality and have an impact on the
 * {@link module:ui/toolbar/toolbarview~ToolbarView#element} template or
 * {@link module:ui/toolbar/toolbarview~ToolbarView#render rendering}. They can be enabled
 * conditionally, e.g. depending on the configuration of the toolbar.
 *
 * @private
 * @interface module:ui/toolbar/toolbarview~ToolbarBehavior
 */
        /**
 * Creates a new toolbar behavior instance.
 *
 * The instance is created in the {@link module:ui/toolbar/toolbarview~ToolbarView#constructor} of the toolbar.
 * This is the right place to extend the {@link module:ui/toolbar/toolbarview~ToolbarView#template} of
 * the toolbar, define extra toolbar properties, etc.
 *
 * @method #constructor
 * @param {module:ui/toolbar/toolbarview~ToolbarView} view An instance of the toolbar that this behavior is added to.
 */
        /**
 * A method called after the toolbar has been {@link module:ui/toolbar/toolbarview~ToolbarView#render rendered}.
 * It can be used to, for example, customize the behavior of the toolbar when its {@link module:ui/toolbar/toolbarview~ToolbarView#element}
 * is available.
 *
 * @readonly
 * @member {Function} #render
 * @param {module:ui/toolbar/toolbarview~ToolbarView} view An instance of the toolbar being rendered.
 */
        /**
 * A method called after the toolbar has been {@link module:ui/toolbar/toolbarview~ToolbarView#destroy destroyed}.
 * It allows cleaning up after the toolbar behavior, for instance, this is the right place to detach
 * event listeners, free up references, etc.
 *
 * @readonly
 * @member {Function} #destroy
 */